export default {
  brandTag: "العب • اكتشف • تعلّم",
  navProfile: "الملف الشخصي", navDashboard: "لوحة التحكم", navStats: "إحصائياتي", navAbout: "من نحن",
  searchPh: "دوّر على حاجة...",
  menuProfile: "الملف الشخصي", menuLogout: "تسجيل الخروج",
  notif1t: "تم فتح إنجاز جديد! 🎉", notif1s: "منذ ساعتين",
  notif2t: "تذكير: موعد المشروع بعد 3 أيام", notif2s: "أمس",
  notificationsEmpty: "لا توجد إشعارات حالياً",
  aboutTitle: "تعرّف على LUDUS",
  aboutDesc: "LUDUS منصة تعلّم تفاعلية بتحوّل المذاكرة لتجربة ممتعة عن طريق الاستكشاف والتحديات والتعلّم القائم على الألعاب.",
  aboutEyebrow: "تعلّم بطريقة مختلفة",
  aboutHighlightGame: "مختبر ثلاثي الأبعاد", aboutHighlightScenarios: "9 سيناريوهات واقعية", aboutHighlightFeedback: "تقييم فوري",
  missionTitle: "مهمتنا",
  missionText: "نخلّي التعلّم أكتر تفاعلية وسهل الوصول وممتع — نساعد الطلاب يبنوا مهاراتهم ويوصلوا لكامل إمكانياتهم.",
  visionTitle: "رؤيتنا",
  visionText: "مستقبل كل طالب فيه يقدر يتعلّم بالطريقة اللي تناسب أسلوبه واهتماماته وأهدافه — في أي وقت ومن أي مكان.",
  valuesTitle: "قيمنا",
  valuesEyebrow: "المبادئ اللي بنبني عليها",
  curiosityT: "الفضول", curiosityD: "بنؤمن بقوة الأسئلة.",
  inclusionT: "الشمول", inclusionD: "التعلّم للجميع.",
  innovationT: "الابتكار", innovationD: "بننمو من خلال أفكار جديدة.",
  impactT: "التأثير", impactD: "إحنا هنا عشان نفرق.",
  tagline: "التعلّم أحلى لما تعيشه بنفسك",
  dashHeroT: "أهلاً بيك تاني!",
  dashHeroD: "كمّل رحلتك في التعلّم من حيث ما وقفت — تحديات وسيناريوهات جديدة في انتظارك النهاردة.",
  botName: "لُدّي", botSub: "رفيقك الذكي في التعلّم", botGreet: "أهلاً! أقدر أساعدك إزاي؟", botPh: "اسألني أي حاجة...",
  botOpen: "افتح المساعد", botClose: "إغلاق المساعد", botSend: "إرسال الرسالة", botDrag: "اسحب لتحريك المساعد",
  botHide: "إخفاء المساعد", botShow: "إظهار المساعد",
  journeyTitle: "رحلة التعلّم",
  gameTitle: "التعلّم باللعب", gameDesc: "تحديات وألعاب تفاعلية",
  scenTitle: "التعلّم بالسيناريوهات", scenDesc: "مواقف واقعية تطبّق فيها اللي اتعلمته",
  gameBadge: "لعبة تفاعلية", scenarioBadge: "تجربة واقعية", playNow: "العب الآن", exploreNow: "ابدأ السيناريو",
  deadlinesTitle: "مهام التعلّم بالسيناريو",
  streakLabel: "تتابع تسجيل الدخول", streakVal: "اليوم الأول!", streakSub: "بداية موفّقة — كمّل كده!",
  recentsTitle: "آخر النشاطات", noRecentActivity: "لا توجد نشاطات بعد — افتح سيناريو ليظهر هنا.",
  perfTitle: "الأداء والتقدّم", perfLabel: "نسبة الأداء", progLabel: "نسبة التقدّم",
  pName: "آية شافعي", pUni: "الجامعة البريطانية في مصر",
  pFaculty: "كلية المعلوماتية وعلوم الحاسب", pAge: "20 سنة",
  editProfile: "تعديل الملف", pQuote: "\"متعلّمين أفضل، مستقبل أحلى\"",
  bioTitle: "نبذة",
  bioText: "طالبة علوم حاسب في BUE، دايمًا فضولية ودايمًا بتتعلم. بحب أحوّل الأفكار لمشاريع حقيقية، ومؤمنة إن التعلّم لازم يكون ممتع (وفيه شوية لعب 😉).",
  interestsTitle: "الاهتمامات",
  favTitle: "المادة المفضّلة",
  prefTitle: "التفضيلات والحساب",
  settingsT: "الإعدادات", settingsD: "إدارة الحساب والتنبيهات",
  privacyT: "الخصوصية", privacyD: "تحكّم فيما تشاركه",
  langT: "اللغة", logoutT: "تسجيل الخروج", logoutD: "الخروج من الحساب",
  journeyStatsTitle: "رحلة تعلّمك", lvlName: "المستكشف",
  streakDays: "يوم متتالي", achievements: "الإنجازات", certificates: "الشهادات",
  aboutBannerT: "من نحن", aboutBannerD: "اتعرّف أكتر على LUDUS ورسالتنا",
  langSelfName: "العربية",
  loading: "جاري التحميل...", errorTitle: "حدث خطأ", retry: "حاول مرة أخرى",
  notAvailableYet: "ليست متاحة بعد", notAvailableDesc: "نعمل على تجهيز هذه الصفحة قريباً.",
  emptyTitle: "لا يوجد محتوى",
  navScenarios: "السيناريوهات",
  scenariosTitle: "التعلّم بالسيناريوهات",
  scenariosDesc: "اختر سيناريو لتبدأ رحلة التعلم التفاعلي — اقرأ الموقف، أجب، واحصل على تقييم فوري.",
  scenarioEyebrow: "مواقف من عالم الصيدلة الحقيقي", scenarioCount: "سيناريوهات", instantFeedback: "تقييم فوري",
  startScenario: "ابدأ التحدي", simpleSteps: "3 خطوات بسيطة",
  scenarioStep1T: "افهم الموقف", scenarioStep1D: "اقرأ حالة واقعية وحدّد تفاصيلها المهمة.",
  scenarioStep2T: "حلّل واتخذ قرارًا", scenarioStep2D: "استخدم معرفتك للإجابة على السؤال الاستكشافي.",
  scenarioStep3T: "تعلّم من التقييم", scenarioStep3D: "استلم تقييمًا فوريًا وطوّر فهمك خطوة بخطوة.",
  scenariosHowTitle: "إزاي بتشتغل؟",
  sessionTitle: "جلسة التعلم",
  sessionEmptyTitle: "اختر سيناريو أولاً",
  sessionEmptyDesc: "ارجع لقائمة السيناريوهات واختر واحداً لتبدأ الجلسة.",
  backToScenarios: "رجوع للسيناريوهات",
  contextLabel: "الموقف",
  challengeLabel: "التحدي",
  questionLabel: "السؤال الاستكشافي",
  answerPlaceholder: "اكتب إجابتك هنا...",
  submitBtn: "إرسال الإجابة",
  submitting: "جاري الإرسال...",
  stageLabel: "المرحلة",
  microLessonTitle: "الدرس المصغّر",
  correctNoLesson: "إجابة صحيحة — لا حاجة لدرس مصغّر.",
  reChallengeLabel: "إعادة التحدي",
  masteredTitle: "أتقنت المهارة! 🎉",
  retryTitle: "محتاج مراجعة",
  tryAgain: "حاول مرة أخرى",
  botReplies: [
    "أنا لسه بوت تجريبي 🙂 الدردشة الذكية الحقيقية جاية قريب!",
    "تمام، سجّلت طلبك — هطوّر الميزة دي قريب!",
    "فكرة حلوة! هحطها في قايمة المهام 📝",
  ],
};
